import LineChartCustom from "../../components/Incidents/charts/LineChart";

const xLabels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const processData = (dayNightData) => {
  if (dayNightData) {
    const dayData = Array(7).fill(0);
    const nightData = Array(7).fill(0);

    xLabels.forEach((day, index) => {
      const dayEntry = dayNightData[day] || {};
      dayData[index] = dayEntry.Day ? dayEntry.Day.avg : 0;
      nightData[index] = dayEntry.Night ? dayEntry.Night.avg : 0;
    });

    return [
      { data: dayData, label: "Day", showMark: true, curve: "linear", color: "#F4A462" },
      { data: nightData, label: "Night", showMark: true, curve: "linear", color: "#274754" },
    ];
  } else return [];
};

const AverageResponseTimesOverTime = ({ data }) => {
  const series = processData(data);

  return <LineChartCustom xLabels={xLabels} series={series} />;
};

export default AverageResponseTimesOverTime;
